import qs from 'qs';
import cleanDeep from 'clean-deep';

const reviewsEndpoint = (endPoint, id) => ({
  dataURL: `${endPoint}/reviews/${id}`,
  sourceName: 'reviews',
  autoLoad: true,
  getDataUrl: (url, { page, perPage }) => {
    const urlData = {};

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta } = payload;
    const { limit, count, offset } = meta || {};

    return {
      data: concat ? (state.data || []).concat(payload) : payload,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count
    };
  }
});

export default reviewsEndpoint;
